import React from 'react';

const ExternalLink = ({ href, children, ...other }) => (
  <a href={href} {...other} rel="noreferrer noopener" target="_blank" css="color: #3770ff">
    {children}
  </a>
);

export default ExternalLink;
